module.exports = __webpack_public_path__ + "a6e3a6c0ebd741cad9e890c03d7d52d1.fbx";